import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import LinearProgress from "@mui/material/LinearProgress";
import classnames from "classnames";
import { useStyles } from "./LinearProgressBar.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function LinearProgressBar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else LinearProgressBar_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const LinearProgressBar = (t0)=>{
    const $ = c(22);
    let className;
    let color;
    let height;
    let rest;
    let t1;
    let t2;
    let value;
    let valueBuffer;
    if ($[0] !== t0) {
        ({ variant: t1, value, valueBuffer, color, height, transparentBackground: t2, className } = t0), rest = _object_without_properties(t0, [
            "variant",
            "value",
            "valueBuffer",
            "color",
            "height",
            "transparentBackground",
            "className"
        ]);
        $[0] = t0;
        $[1] = className;
        $[2] = color;
        $[3] = height;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
        $[7] = value;
        $[8] = valueBuffer;
    } else {
        className = $[1];
        color = $[2];
        height = $[3];
        rest = $[4];
        t1 = $[5];
        t2 = $[6];
        value = $[7];
        valueBuffer = $[8];
    }
    const variant = void 0 === t1 ? "indeterminate" : t1;
    const transparentBackground = void 0 === t2 ? false : t2;
    let t3;
    if ($[9] !== color || $[10] !== height || $[11] !== transparentBackground) {
        t3 = {
            height,
            color,
            transparentBackground
        };
        $[9] = color;
        $[10] = height;
        $[11] = transparentBackground;
        $[12] = t3;
    } else t3 = $[12];
    const { classes } = useStyles(t3);
    let t4;
    if ($[13] !== className || $[14] !== classes.root) {
        t4 = classnames(classes.root, className, "aqa_linear_progress");
        $[13] = className;
        $[14] = classes.root;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== rest || $[17] !== t4 || $[18] !== value || $[19] !== valueBuffer || $[20] !== variant) {
        t5 = /*#__PURE__*/ jsx(LinearProgress, _object_spread_props(_object_spread({}, rest), {
            "data-testid": "linear-progress",
            variant: variant,
            value: value,
            valueBuffer: valueBuffer,
            className: t4
        }));
        $[16] = rest;
        $[17] = t4;
        $[18] = value;
        $[19] = valueBuffer;
        $[20] = variant;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
};
export { LinearProgressBar };
